import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import CardBanner from './card-banner/card-banner.component.js';
import CardContent from './card-content/card-content.component.js';
import CardHeader from './card-header/card-header.component.js';
import CardImage from './card-image/card-image.component.js';
import { StyledCard } from './card.style.js';

const Card = (props) => {
    const { className = '', children, margin, mobileVariant = 'hover' } = props, rest = __rest(props, ["className", "children", "margin", "mobileVariant"]);
    return (jsx(StyledCard, Object.assign({ className: className, margin: margin, mobileVariant: mobileVariant }, rest, { children: children }), void 0));
};
Card.Content = CardContent;
Card.Header = CardHeader;
Card.Banner = CardBanner;
Card.Image = CardImage;

export { Card };
